export default __webpack_public_path__ + "static/media/arrowup.e02d6b12.svg";